import { render, staticRenderFns } from "./LouverPaints.vue?vue&type=template&id=45f8239e&scoped=true&"
import script from "./LouverPaints.vue?vue&type=script&lang=js&"
export * from "./LouverPaints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f8239e",
  null
  
)

export default component.exports